// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M12.9373 5.45902L4.70535 10.0323C2.97468 10.9937 2.97468 13.4817 4.70535 14.443L12.9373 19.0163C14.8413 20.0737 17.1573 20.0737 19.0627 19.0163L27.2947 14.443C29.0254 13.4817 29.0254 10.9937 27.2947 10.0323L19.0627 5.45902C17.1573 4.40168 14.8427 4.40168 12.9373 5.45902Z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M7.98804 16.2666V21.4986C7.98804 22.7639 8.62137 23.9439 9.67337 24.6439L11.816 26.0693C14.3507 27.7546 17.6494 27.7546 20.1827 26.0693L22.3254 24.6439C23.3787 23.9439 24.0107 22.7626 24.0107 21.4986V16.2666"
    />
  </svg>
);
const IconStudentHat = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconStudentHat;
